Util = require 'lib/util'
View = require 'view'
template = require 'views/templates/org_prefs_nonorg_invites'

module.exports = class OrganizationAllowNonOrgBoardInvitesView extends View
  viewTitleKey: 'inviting guests'

  initialize: ->
    @listenTo @model, 'change:prefs', @render

  events:
    'click a': 'setPref'

  render: ->
    data = @model.toJSON(prefs: true, url: true, premium: true)

    data.externalMembersDisabled = data.prefs.externalMembersDisabled

    @$el.html template(data)

    @

  setPref: (e) ->
    Util.stop(e)

    if e.target.parentElement.classList.contains('active')
      return
    else
      @model.setPref('externalMembersDisabled', !@model.getPref('externalMembersDisabled'))
    return



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-allow-non-org-board-invites-view.coffee